import {
    CreateProgrammesDumpReduxState,
    ProgrammesDumpReportReducerDispatch,
    ProgrammesDumpReportReduxTypes
} from "./types";

const CREATE_PROGRAMMES_DUMP_INIT_STATE: CreateProgrammesDumpReduxState = {
    data: {},
    loading: false,
    error: null
};

const CreateProgrammesDumpReportReducer = (
    state: CreateProgrammesDumpReduxState = CREATE_PROGRAMMES_DUMP_INIT_STATE,
    action: ProgrammesDumpReportReducerDispatch
) => {
    switch (action.type) {
        case ProgrammesDumpReportReduxTypes.PROGRAMMES_DUMP_REPORT: {
            return {
                ...state,
                loading: true
            };
        }

        case ProgrammesDumpReportReduxTypes.PROGRAMMES_DUMP_REPORT_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            };
        }

        case ProgrammesDumpReportReduxTypes.PROGRAMMES_DUMP_REPORT_ERROR: {
            return {
                data: {},
                error: action.payload.error,
                loading: false
            };
        }

        default:
            return { ...state };
    }
};

export { CreateProgrammesDumpReportReducer };